import React, { useState } from 'react';
import CommandTooltip from './CommandTooltip';

const CommandList = ({ commands, lockedCommands, searchQuery, userTier, onCommandClick }) => {
  const [hoveredCommand, setHoveredCommand] = useState(null);

  // Highlight search matches in text
  const highlightText = (text, query) => {
    if (!query || !text) return text;
    
    const parts = text.split(new RegExp(`(${query})`, 'gi'));
    return parts.map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <mark key={i} className="search-highlight">{part}</mark>
      ) : (
        part
      )
    );
  };

  const getTierBadgeColor = (tier) => {
    const tierLower = (tier || 'free').toLowerCase();
    switch (tierLower) {
      case 'free':
        return '#10b981'; // green
      case 'pro':
        return '#3b82f6'; // blue
      case 'team':
        return '#8b5cf6'; // purple
      case 'enterprise':
        return '#f59e0b'; // amber
      default:
        return '#6b7280'; // gray
    }
  };

  if (commands.length === 0 && lockedCommands.length === 0) {
    return (
      <div className="baiql-command-list-empty">
        <p>No commands found{searchQuery ? ` matching "${searchQuery}"` : ''}.</p>
      </div>
    );
  }

  return (
    <div className="baiql-command-list">
      {/* Available Commands */}
      {commands.length > 0 && (
        <div className="baiql-command-list-section">
          <div className="baiql-command-list-header">
            Available Commands ({commands.length})
          </div>
          {commands.map((command, index) => (
            <CommandTooltip
              key={command.name}
              command={command}
              searchQuery={searchQuery}
            >
              <button
                className="baiql-command-item"
                onMouseEnter={() => setHoveredCommand(command.name)}
                onMouseLeave={() => setHoveredCommand(null)}
                onClick={() => onCommandClick(command)}
              >
                <div className="baiql-command-item-header">
                  <code className="baiql-command-name">
                    {highlightText(command.name, searchQuery)}
                  </code>
                  <span
                    className="baiql-command-tier-badge"
                    style={{ backgroundColor: getTierBadgeColor(command.tier) }}
                  >
                    {(command.tier || 'free').toUpperCase()}
                  </span>
                </div>
                <div className="baiql-command-syntax">
                  <code>{highlightText(command.syntax, searchQuery)}</code>
                </div>
                <div className="baiql-command-desc">
                  {highlightText(command.quickDesc, searchQuery)}
                </div>
              </button>
            </CommandTooltip>
          ))}
        </div>
      )}

      {/* Locked Commands */}
      {lockedCommands.length > 0 && (
        <div className="baiql-command-list-section">
          <div className="baiql-command-list-header locked">
            <span>🔒 Upgrade to Unlock ({lockedCommands.length})</span>
          </div>
          {lockedCommands.map((command) => (
            <CommandTooltip
              key={command.name}
              command={command}
              searchQuery={searchQuery}
              isLocked={true}
            >
              <button
                className="baiql-command-item locked"
                disabled
                onMouseEnter={() => setHoveredCommand(command.name)}
                onMouseLeave={() => setHoveredCommand(null)}
                onClick={() => {
                  // Show upgrade message
                  alert(`Upgrade to ${(command.tier || 'pro').toUpperCase()} tier to use ${command.name}`);
                }}
              >
                <div className="baiql-command-item-header">
                  <code className="baiql-command-name">
                    {highlightText(command.name, searchQuery)}
                  </code>
                  <span
                    className="baiql-command-tier-badge"
                    style={{ backgroundColor: getTierBadgeColor(command.tier) }}
                  >
                    {(command.tier || 'pro').toUpperCase()}
                  </span>
                </div>
                <div className="baiql-command-syntax">
                  <code>{highlightText(command.syntax, searchQuery)}</code>
                </div>
                <div className="baiql-command-desc">
                  {highlightText(command.quickDesc, searchQuery)}
                </div>
                <div className="baiql-command-locked-message">
                  Requires {(command.tier || 'pro').toUpperCase()} tier
                </div>
              </button>
            </CommandTooltip>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommandList;

